// extracted by mini-css-extract-plugin
export default {"note":"RedeemData_note__tKm42","title":"RedeemData_title__K94ej","text":"RedeemData_text__AgmTd"};